import "core-js/modules/es.promise.finally.js";
import _slicedToArray from "/home/kbus/kbus-website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useMemo, useState } from 'react';
import debounce from './lib/debounce';
import flattenOptions from './lib/flattenOptions';
export default function useFetch(q, defaultOptions, _ref) {
  var debounceTime = _ref.debounceTime,
      filterOptions = _ref.filterOptions,
      getOptions = _ref.getOptions;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      fetching = _useState2[0],
      setFetching = _useState2[1];

  var _useState3 = useState(function () {
    return flattenOptions(defaultOptions);
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      options = _useState4[0],
      setOptions = _useState4[1];

  var fetch = useMemo(function () {
    var filter = filterOptions || function (op) {
      return function () {
        return op;
      };
    };

    if (!getOptions) {
      return function (s) {
        return setOptions(flattenOptions(filter(defaultOptions)(s)));
      };
    }

    return debounce(function (s) {
      var optionsReq = getOptions(s, defaultOptions);
      setFetching(true);
      Promise.resolve(optionsReq).then(function (newOptions) {
        setOptions(flattenOptions(filter(newOptions)(s)));
      }).finally(function () {
        return setFetching(false);
      });
    }, debounceTime);
  }, [filterOptions, defaultOptions, getOptions, debounceTime]);
  useEffect(function () {
    return setOptions(defaultOptions);
  }, [defaultOptions]);
  useEffect(function () {
    return fetch(q);
  }, [fetch, q]);
  return {
    options: options,
    setOptions: setOptions,
    fetching: fetching
  };
}